jQuery.feature_import("js-productdata-init",
  () => require("./productdata-init.js"),
  mod => mod.feature_js_productdata_init
);